<otw-listing-dataview [listings]="listings()" layout="grid" [showSorting]="false" [showPagination]="false"
  [pageSize]="8" [loading]="isLoading()">
  <ng-template #listing let-listing>
    <div class="shadow-xl hover:shadow-2xl rounded-sm transition-shadow duration-300 overflow-hidden flex flex-col">
      <div class="relative aspect-[4/3] bg-gray-100">
        <img [src]="getImageUrls(listing)[0]" class="absolute inset-0 w-full h-full object-cover" alt="Няма изображение"
          (error)="setDefaultImg($event)" />
      </div>

      <div class="h-44 px-2 flex flex-col justify-between">
        <h2
          class="py-1 text-lg md:text-xl text-gray font-inter font-semibold mb-1 line-clamp-2 sm:line-clamp-1 xl:line-clamp-2">
          {{ listing.title }}
        </h2>
        <div class="flex flex-col py-2 gap-1">
          <span class="text-commonGray text-sm">
            {{getConditionLabel(listing.condition)}}
          </span>
          <span class="text-gray font-bold font-inter text-lg">
            {{ listing.price | number : "1.2-2" }} €
          </span>
          <a [routerLink]="['/listing', listing.slug]"
            class="rounded-sm bg-primary-400 text-white px-3 py-2 text-center hover:bg-green-700 transition-colors">
            ВИЖ ПОВЕЧЕ
          </a>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #listingLoading let-listing>
    <div class="border rounded-md border-lightGray">
      <div class="aspect-[4/3]"><p-skeleton width="100%" height="100%" /></div>
      <div class="h-32 flex flex-col p-2 gap-1">
        <div class="flex-1"><p-skeleton width="100%" height="100%" /></div>
        <div class="flex-1">
          <p-skeleton width="100%" height="100%" />
        </div>
      </div>
    </div>
  </ng-template>

</otw-listing-dataview>
